import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { admin } = useAuth();

  if (admin === null) {
    return (
      <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center text-[#8B7A70]">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
